export enum API_REQUEST_HEADER {
    current_organisation_id = 'Current-Organisation-Id',
    firebase_token = 'Firebase-Token',
}
